/**
 * @file Contributor UI — bulkImportRecordKey. Row shape returned by bulk import preview / commit APIs. */

export type BulkImportRecordKeySource = {
  code?: string;
  recordKey?: string;
  submission_code?: string;
};

const HEADER_PLACEHOLDER_KEYS = new Set([
  "submission_code",
  "submission code",
  "submissioncode",
]);

/** Resolve the user-facing record key from API rows (prefers `code`, skips header placeholders). */
export function resolveBulkRecordKey(row: BulkImportRecordKeySource | string | null | undefined): string {
  if (typeof row === "string") {
    const s = row.trim();
    return isHeaderPlaceholderKey(s) ? "" : s;
  }

  if (!row) return "";

  for (const candidate of [row.code, row.recordKey, row.submission_code]) {
    const s = String(candidate ?? "").trim();
    if (!s || isHeaderPlaceholderKey(s)) continue;
    return s;
  }

  return "";
}

function isHeaderPlaceholderKey(value: string): boolean {
  const normalized = value.trim().toLowerCase().replace(/\s+/g, " ");
  return HEADER_PLACEHOLDER_KEYS.has(normalized.replace(/ /g, "_")) || HEADER_PLACEHOLDER_KEYS.has(normalized);
}
